import {scroll} from '../global/locomotive-custom';

export default function () {
    const trigger = document.querySelector('.scrollToTop')

    if (trigger !== null) {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            scroll.scrollTo('top', {behavior: 'smooth'});
        });
    }

}